import {
  GET_TOTAL_PURCHASE_ORDERS,
  GET_TOTAL_PURCHASE_ORDERS_SUCCESS,
  GET_TOTAL_PURCHASE_ORDERS_ERROR
} from './PurchaseOrdersSection.actions'

const totalPurchaseOrdersState = {
  loading: true,
  error: undefined,
  rangeDate: {
    initialMonth: null,
    initialYear: null,
    finalMonth: null,
    finalYear: null
  },
  purchaseOrders: [
    {
      name: '',
      orders: 0,
      amount: 0,
      percentage: 0
    }
  ],
  hasData: false,
  totalOrder: 0
}

/**
 * The Purchase Orders reducer.
 */
const totalPurchaseOrderReducer = (state = totalPurchaseOrdersState, { payload, type }) => {
  switch (type) {
    case GET_TOTAL_PURCHASE_ORDERS: {
      return { ...state, loading: true }
    }
    case GET_TOTAL_PURCHASE_ORDERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        hasData: payload?.hasData,
        purchaseOrders: payload?.purchaseOrders,
        rangeDate: payload?.rangeDate,
        totalOrder: payload?.total
      }
    }
    case GET_TOTAL_PURCHASE_ORDERS_ERROR: {
      return { ...state, loading: false }
    }
    default: {
      return state
    }
  }
}

export default totalPurchaseOrderReducer
